export default "__VITE_ASSET__DWC2_iVT__"